import React from "react";
import { Switch } from 'react-router-dom';
import { errorLayout } from '../../layouts/ErrorLayout';
import PublicLayout from '../../layouts/PublicLayout/PublicLayout';
import AppRoute from '../AppRoute';
import Loader from '../../helper/loaders';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import { auth } from '../../utils/authentication/auth';
// import AuthLayout from "../../layouts/AuthLayout/AuthLayout";

const List = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Activities/AllActivities')
);

const ByProduct = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Activities/ProductActivity')
);

const Detail = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Password/ResetPassword')
);

const IdleActivitiesByProdcut = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Activities/IdleProductActivity')
);

const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/not-found-page.component')
);


const AuthComponent = (props) => {
    let { match } = props;

    return (
        <React.Fragment>
            <Switch>

                <AppRoute
                    path={`${match.path}/list-all`}
                    component={List}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='All Activities'
                />

                <AppRoute
                    //exact={true}
                    path={`${match.path}/product/:id`}
                    component={ByProduct}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='public'
                    title='Product Activities'
                />
                <AppRoute
                    //exact={true}
                    path={`${match.path}/detail/:id`}
                    component={Detail}
                    layout={PublicLayout}
                    type='public'
                    title='Activity Detail'
                />
                <AppRoute
                    //exact={true}
                    path={`${match.path}/idle/product/:id`}
                    component={IdleActivitiesByProdcut}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='public'
                    title='Products Idle Activities'
                />
                <AppRoute
                    path={`${match.path}/*`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

                <AppRoute
                    exact
                    path={`${match.path}`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </React.Fragment>
    )
};

export default AuthComponent;